export const pageTitle = title => {
  return (document.title =
    title + ' -  VitusCare Medlife PVT LTD');
};
